const SET_LOAN_DETAILS = "SET_LOAN_DETAILS";
const SAVE_LOAN_DETAILS = "SAVE_LOAN_DETAILS";

export { SET_LOAN_DETAILS, SAVE_LOAN_DETAILS };

export const TOGGLE_RIDER_FORM = "TOGGLE_RIDER_FORM";

export const SET_RIDER_SELECTION_LOCKED = "SET_RIDER_SELECTION_LOCKED";
